import React from 'react'
import classNames from 'classnames'
import styles from './style.module.scss'

export type BannerType = 'download-rider' | 'onboard' | 'download-waze'
interface IBannerProps {
  body: string
  link: string
  cta: string
  bannerType: BannerType
  localStorageKey: string
}

const gtmClassByType = {
  onboard: 'gtm-onboard-banner',
  'download-rider': 'gtm-download-app-banner',
  'download-waze': 'gtm-download-waze-banner'
}

const logoClassesByType = {
  onboard: styles.onboardLogo,
  'download-rider': styles.riderAppLogo,
  'download-waze': styles.wazeAppLogo
}

const whiteLogoClassesByType = {
  onboard: styles.carpoolWhiteLogo,
  'download-rider': styles.carpoolWhiteLogo,
  'download-waze': styles.wazeWhiteLogo
}

const bgColorByType = {
  onboard: styles.bgRider,
  'download-rider': styles.bgRider,
  'download-waze': styles.bgDriver
}

const isClosed = (localStorageKey: string) => {
  const lastClosedStr = localStorage.getItem(localStorageKey)
  if (!lastClosedStr) {
    return false
  }
  const lastClosed = parseInt(lastClosedStr, 10)
  return lastClosed && Date.now() - lastClosed < 60 * 20 * 1000 // 20 minutes
}

export const Banner: React.FunctionComponent<IBannerProps> = ({
  bannerType,
  body,
  link,
  cta,
  localStorageKey
}) => {
  const [slideUp, toggle] = React.useState(false)
  const closed = isClosed(localStorageKey)

  const onClose = () => {
    toggle(true)
    localStorage.setItem(localStorageKey, Date.now().toString())
  }

  const logoClasses = classNames(logoClassesByType[bannerType], styles.appLogo)

  // TODO: align with the standard method for GA tagging in carpool (data-ga-action)
  const gtmClass = gtmClassByType[bannerType]

  return (
    <div
      className={classNames(
        gtmClass,
        styles.downloadAppBanner,
        bgColorByType[bannerType],
        slideUp && styles.slideUp,
        closed && styles.bannerClosed
      )}
    >
      <div
        onClick={onClose}
        className={classNames('w-icon-x', `${gtmClass}--close`, styles.closeButton)}
      />
      <div className={logoClasses} />
      <div className={styles.logoAndBody}>
        <div className={whiteLogoClassesByType[bannerType]} />
        <span>{body}</span>
      </div>
      <a className={classNames(styles.bannerCtaButton, `${gtmClass}--click`)} href={link}>
        {cta}
      </a>
    </div>
  )
}
